'use client';

// npm library imports
import Image from 'next/image';

// style imports
import styles from './navbar.module.scss';

// image imports
import crocLogo from '@public/images/logos/logo-white.png';
import warriorLogo from '@public/images/logos/warrior_logo_nav.png';

/**
 * Navbar component with sidemenus and contact dropdown
 *
 * @returns The Navbar component JSX.Element
 *
 * @example
 * ```tsx
 * <Navbar />
 * ```
 */
const Navbar = () => {
    return (
        <>
            {/* Navbar Container */}
            <nav className={styles.navbar}>
                {/* Warrior Logo */}
                <div className={styles.logo}>
                    <a
                        href="https://thecrocodilehunterlodge.com.au/dining"
                        target="_blank"
                    >
                        <Image
                            priority
                            src={warriorLogo}
                            width={150}
                            height={35}
                            alt="Warrior Logo"
                            placeholder="blur"
                        />
                    </a>
                </div>
                {/* CHL Logo */}
                <div className={styles.logo}>
                    <a
                        href="https://thecrocodilehunterlodge.com.au"
                        target="_blank"
                    >
                        <Image
                            priority
                            src={crocLogo}
                            width={150}
                            height={35}
                            alt="Crocodile Hunter Lodge Logo"
                            placeholder="blur"
                        />
                    </a>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
